<script>
import Layout from "../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import Swal from "sweetalert2";
import { authFackMethods } from "@/state/helpers";

import { required } from "vuelidate/lib/validators";

export default {
  page: {
    title: "Roles",
    meta: [
      {
        name: "Roles",
      },
    ],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
      roles: {},
      currentUserData: JSON.parse(localStorage.getItem("user")),
      isMinneapolis: false,
      roleId: "",
      preservePage: 1,
      pageLimit: 500,
      modalTitle: "",
      status: [
        { value: "active", text: "Active" },
        { value: "inactive", text: "InActive" },
      ],
      locations: [],
      categories: [],
      types: [
        { value: "volunteer", text: "Volunteer" },
        { value: "mentor", text: "Mentor" },
      ],
      searchBy: "",
      roleForm: {
        name: "",
        description: "",
        special_requirement: "",
        time_slots: {
          monday: {
            is_checked: false,
            time: "",
          },
          tuesday: {
            is_checked: false,
            time: "",
          },
          wednesday: {
            is_checked: false,
            time: "",
          },
          thursday: {
            is_checked: false,
            time: "",
          },
          friday: {
            is_checked: false,
            time: "",
          },
          saturday: {
            is_checked: false,
            time: "",
          },
          sunday: {
            is_checked: false,
            time: "",
          },
        },
        status: null,
        // location_id: null,
        category_id: null,
        type: null,
        age_limit: "",
        capacity: "",
      },
      rolesubmit: false,
      searchForm: {
        name: null,
        status: null,
        category: null,
      },
      typesubmit: false,
      isUpdate: false,
      isAdd: false,
      isName: false,
      isStatus: false,
      isCategory: false,
      isSearching: false,
      isLoading: false,
      noRecord: false,
    };
  },
  validations: {
    roleForm: {
      name: { required },
      description: { required },
      status: { required },
      special_requirement: { required },
      // time_slots:{required},
      // location_id: { required },
      category_id: { required },
      type: { required },
      age_limit: { required },
      capacity: { required },
    },
  },
  mounted() {
    this.getRoles();
  },
  methods: {
    containsMinneapolis(locationIds = []) {
      const minneapolis = 2;
      return locationIds.indexOf(minneapolis) > -1;
    },

    getRoles(page) {
      if (this.currentUserData["user_type_id"] == 10) {
        if (this.containsMinneapolis(this.currentUserData["locations"])) {
          this.isMinneapolis = true;
        } else {
          this.isMinneapolis = false;
        }
      }
      this.isLoading = true;
      this.noRecord = false;
      if (typeof page === "undefined") {
        page = 1;
      }
      this.preservePage = page;
      let filter = "&per_page=" + this.pageLimit;
      if (this.searchForm.name) {
        filter += "&name=" + this.searchForm.name;
      }
      if (this.searchForm.category) {
        filter += "&category=" + this.searchForm.category;
      }
      if (this.searchForm.status) {
        filter += "&status=" + this.searchForm.status;
      }
      if (this.currentUserData["user_type_id"] == 10) {
        filter += "&location_id=" + this.currentUserData["locations"].join(",");
      }
      axios
        .get("admin/roles?pagination=true&page=" + page + filter)
        .then((res) => {
          this.roles = res.data.response;
          this.isLoading = false;
          if (!this.roles.length) {
            this.noRecord = true;
            if (page > 1) {
              this.getRoles(page - 1);
              this.categories();
            }
          }
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status == 401) {
              this.logout();
            }
          }
        });
    },
    ...authFackMethods,

    showAddModal() {
      this.modalTitle = "Add Role";
      this.$bvModal.show("roleModal");
      this.isAdd = true;
      this.isUpdate = false;
      // this.getLocations();
      this.getCategories();
      this.roleForm = {
        name: "",
        description: "",
        special_requirement: "",
        time_slots: {
          monday: {
            is_checked: false,
            time: "",
          },
          tuesday: {
            is_checked: false,
            time: "",
          },
          wednesday: {
            is_checked: false,
            time: "",
          },
          thursday: {
            is_checked: false,
            time: "",
          },
          friday: {
            is_checked: false,
            time: "",
          },
          saturday: {
            is_checked: false,
            time: "",
          },
          sunday: {
            is_checked: false,
            time: "",
          },
        },
        status: null,
        location_id: null,
        category_id: null,
        type: null,
        age_limit: "",
        capacity: "",
      };
    },

    showEditModal(role) {
      this.getCategories();
      this.modalTitle = "Edit Role";
      this.$bvModal.show("roleModal");
      this.roleForm.name = role.name;
      this.roleForm.description = role.description;
      this.roleForm.special_requirement = role.special_requirement;
      try {
        this.roleForm.time_slots = JSON.parse(role.time_slots);
        if (!this.roleForm.time_slots.sunday) {
          this.roleForm.time_slots.sunday = {
            is_checked: false,
            time: "",
          };
        }
      } catch (err) {
        this.roleForm.time_slots = {
          monday: {
            is_checked: false,
            time: "",
          },
          tuesday: {
            is_checked: false,
            time: "",
          },
          wednesday: {
            is_checked: false,
            time: "",
          },
          thursday: {
            is_checked: false,
            time: "",
          },
          friday: {
            is_checked: false,
            time: "",
          },
          saturday: {
            is_checked: false,
            time: "",
          },
          sunday: {
            is_checked: false,
            time: "",
          },
        };
      }
      // this.roleForm.time_slots = JSON.parse(role.time_slots)?JSON.parse(role.time_slots):this.roleForm.time_slots;
      this.roleForm.status = role.status;
      // this.roleForm.location_id = role.location_id;
      this.roleForm.category_id = role.category_id;
      this.roleForm.type = role.type;
      this.roleForm.age_limit = role.age_limit;
      this.roleForm.capacity = role.capacity;
      this.roleId = role.id;
      this.isUpdate = true;
      this.isAdd = false;
      console.log(this.roleForm);
    },

    deleteRole(role) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        showLoaderOnConfirm: true,
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          var token = localStorage.getItem("token");
          var config = {
            headers: {
              Authorization: "Bearer " + token,
              Accept: "application/json",
            },
          };
          if (token) {
            axios
              .delete("admin/roles/" + role.id, config)
              .then((res) => {
                if (res.status == "200") {
                  Swal.fire({
                    title: "Deleted!",
                    text: role.name + " has been deleted!",
                    icon: "success",
                    width: 350,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  this.getRoles(this.preservePage);
                }
              })
              .catch((err) => {
                if (err.response) {
                  Swal.fire({
                    title: "Error!",
                    text: err.response.data.error.message,
                    icon: "danger",
                    width: 350,
                    showConfirmButton: true,
                  });
                }
              });
          }
        }
      });
    },

    getCategories() {
      let filter = "?pagination=true&per_page=1000";
      if (this.currentUserData["user_type_id"] == 10) {
        filter += "&location_id=" + this.currentUserData["locations"].join(",");
      }

      axios.get("categories" + filter).then((res) => {
        this.categories = res.data.response.data;
      });
    },

    saveRole() {
      this.rolesubmit = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var token = localStorage.getItem("token");
        var config = {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
          },
        };
        if (token) {
          this.roleForm.time_slots = JSON.stringify(this.roleForm.time_slots);
          axios
            .post("admin/roles", this.roleForm, config)
            .then((res) => {
              if (res.status == "200") {
                Swal.fire({
                  title: "Good job!",
                  text: "Role added successfully!",
                  icon: "success",
                  width: 350,
                  showConfirmButton: false,
                  timer: 1500,
                });
                this.getRoles();
                this.$bvModal.hide("roleModal");
                this.roleForm = {
                  name: "",
                  description: "",
                  special_requirement: "",
                  time_slots: {
                    monday: {
                      is_checked: false,
                      time: "",
                    },
                    tuesday: {
                      is_checked: false,
                      time: "",
                    },
                    wednesday: {
                      is_checked: false,
                      time: "",
                    },
                    thursday: {
                      is_checked: false,
                      time: "",
                    },
                    friday: {
                      is_checked: false,
                      time: "",
                    },
                    saturday: {
                      is_checked: false,
                      time: "",
                    },
                    sunday: {
                      is_checked: false,
                      time: "",
                    },
                  },
                  status: null,
                  // location_id: null,
                  category_id: null,
                  type: null,
                  age_limit: "",
                  capacity: "",
                };
              }
            })
            .catch((err) => {
              if (err.response) {
                Swal.fire({
                  title: "Error!",
                  text: err.response.data.error.message,
                  icon: "danger",
                  width: 350,
                  showConfirmButton: true,
                });
              }
            });
        }
      }
    },

    updateRole() {
      this.rolesubmit = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var token = localStorage.getItem("token");
        var config = {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
          },
        };
        if (token) {
          this.roleForm.time_slots = JSON.stringify(this.roleForm.time_slots);
          axios
            .patch("admin/roles/" + this.roleId, this.roleForm, config)
            .then((res) => {
              if (res.status == "200") {
                Swal.fire({
                  title: "Good job!",
                  text: "Role updated successfully!",
                  icon: "success",
                  width: 350,
                  showConfirmButton: false,
                  timer: 1500,
                });
                this.getRoles();
                this.roleForm = {
                  name: "",
                  description: "",
                  special_requirement: "",
                  time_slots: {
                    monday: {
                      is_checked: false,
                      time: "",
                    },
                    tuesday: {
                      is_checked: false,
                      time: "",
                    },
                    wednesday: {
                      is_checked: false,
                      time: "",
                    },
                    thursday: {
                      is_checked: false,
                      time: "",
                    },
                    friday: {
                      is_checked: false,
                      time: "",
                    },
                    saturday: {
                      is_checked: false,
                      time: "",
                    },
                    sunday: {
                      is_checked: false,
                      time: "",
                    },
                  },
                  status: null,
                  location_id: null,
                  category_id: null,
                  type: null,
                  age_limit: "",
                  capacity: "",
                };
                this.$bvModal.hide("roleModal");
              }
            })
            .catch((err) => {
              if (err.response) {
                Swal.fire({
                  title: "Error!",
                  text: err.response.data.error.message,
                  icon: "danger",
                  width: 350,
                  showConfirmButton: true,
                });
              }
            });
        }
      }
    },

    searchOption(event) {
      this.searchForm = {
        name: null,
        status: null,
        category: null,
      };
      let selectedValue = event.target.value;
      if (selectedValue == "") {
        this.resetSearch();
      }
      if (selectedValue == "name") {
        this.isName = true;
        this.isCategory = false;
        this.isStatus = false;
        this.isSearching = true;
      }
      if (selectedValue == "category") {
        this.getCategories();
        this.isName = false;
        this.isCategory = true;
        this.isStatus = false;
        this.isSearching = true;
      }
      if (selectedValue == "status") {
        this.isName = false;
        this.isCategory = false;
        this.isStatus = true;
        this.isSearching = true;
      }
    },

    searchRoles() {
      this.getRoles();
    },

    resetSearch() {
      this.searchForm = {
        name: null,
        status: null,
        category: null,
      };
      this.isSearching = false;
      this.isName = false;
      this.isCategory = false;
      this.isStatus = false;
      this.searchBy = "";
      this.getRoles();
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="card">
      <div class="card-body">
        <div class="d-flex">
          <div class="me-2">
            <h5 class="card-title mb-3">Roles</h5>
          </div>

          <div class="mb-4 mdl-btns ms-auto">
            <!--Add Role Modal-->
            <b-button @click="showAddModal" variant="primary"
              >Add Role</b-button
            >
            <b-modal
              id="roleModal"
              centered
              :title="modalTitle"
              title-class="font-18"
              hide-footer
            >
              <form>
                <div class="mb-3">
                  <label>Role</label>
                  <input
                    v-model="roleForm.name"
                    type="text"
                    class="form-control"
                    placeholder="Enter Role Name"
                    name="name"
                    :class="{
                      'is-invalid': rolesubmit && $v.roleForm.name.$error,
                    }"
                  />
                  <div
                    v-if="rolesubmit && $v.roleForm.name.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.roleForm.name.required"
                      >Role name is required.</span
                    >
                  </div>
                </div>

                <div class="mb-3">
                  <label>Description</label>
                  <div>
                    <textarea
                      v-model="roleForm.description"
                      class="form-control"
                      name="description"
                      :class="{
                        'is-invalid':
                          rolesubmit && $v.roleForm.description.$error,
                      }"
                      rows="3"
                      placeholder="Enter Description"
                    ></textarea>
                    <div
                      v-if="rolesubmit && $v.roleForm.description.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.roleForm.description.required"
                        >Description is required.</span
                      >
                    </div>
                  </div>
                </div>

                <div class="mb-3">
                  <label>Special Requirements</label>
                  <div>
                    <textarea
                      v-model="roleForm.special_requirement"
                      class="form-control"
                      name="special_requirement"
                      :class="{
                        'is-invalid':
                          rolesubmit && $v.roleForm.special_requirement.$error,
                      }"
                      rows="3"
                      placeholder="Enter Special Requirements"
                    ></textarea>
                    <div
                      v-if="
                        rolesubmit && $v.roleForm.special_requirement.$error
                      "
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.roleForm.special_requirement.required"
                        >Special Requirements is required.</span
                      >
                    </div>
                  </div>
                </div>

                <div class="mb-3">
                  <label>Time Slots</label>
                  <div class="row align-items-center mb-3">
                    <div class="col-3 form-check">
                      <input
                        v-model="roleForm.time_slots.monday.is_checked"
                        class="form-check-input"
                        type="checkbox"
                        id="monday"
                      />
                      <label class="" for="monday">Monday</label>
                    </div>
                    <div class="col-md-9">
                      <input
                        v-model="roleForm.time_slots.monday.time"
                        placeholder="Time Slot"
                        class="form-control"
                        id="monday-time"
                        type="text"
                        name="monday-time"
                      />
                    </div>
                  </div>
                  <div class="row align-items-center mb-3">
                    <div class="col-3 form-check">
                      <input
                        v-model="roleForm.time_slots.tuesday.is_checked"
                        class="form-check-input"
                        type="checkbox"
                        id="tuesday"
                      />
                      <label class="" for="tuesday">Tuesday</label>
                    </div>
                    <div class="col-md-9">
                      <input
                        v-model="roleForm.time_slots.tuesday.time"
                        placeholder="Time Slot"
                        class="form-control"
                        id="tuesday-time"
                        type="text"
                        name="monday-time"
                      />
                    </div>
                  </div>
                  <div class="row align-items-center mb-3">
                    <div class="col-3 form-check">
                      <input
                        v-model="roleForm.time_slots.wednesday.is_checked"
                        class="form-check-input"
                        type="checkbox"
                        id="wednesday"
                      />
                      <label class="" for="wednesday">Wednesday</label>
                    </div>
                    <div class="col-md-9">
                      <input
                        v-model="roleForm.time_slots.wednesday.time"
                        placeholder="Time Slot"
                        class="form-control"
                        id="wednesday-time"
                        type="text"
                        name="wednesday-time"
                      />
                    </div>
                  </div>
                  <div class="row align-items-center mb-3">
                    <div class="col-3 form-check">
                      <input
                        v-model="roleForm.time_slots.thursday.is_checked"
                        class="form-check-input"
                        type="checkbox"
                        id="thursday"
                      />
                      <label class="" for="thursday">Thursday</label>
                    </div>
                    <div class="col-md-9">
                      <input
                        v-model="roleForm.time_slots.thursday.time"
                        placeholder="Time Slot"
                        class="form-control"
                        id="thursday-time"
                        type="text"
                        name="wednesday-time"
                      />
                    </div>
                  </div>
                  <div class="row align-items-center mb-3">
                    <div class="col-3 form-check">
                      <input
                        v-model="roleForm.time_slots.friday.is_checked"
                        class="form-check-input"
                        type="checkbox"
                        id="friday"
                      />
                      <label class="" for="friday">Friday</label>
                    </div>
                    <div class="col-md-9">
                      <input
                        v-model="roleForm.time_slots.friday.time"
                        placeholder="Time Slot"
                        class="form-control"
                        id="friday-time"
                        type="text"
                        name="friday-time"
                      />
                    </div>
                  </div>
                  <div class="row align-items-center mb-3">
                    <div class="col-3 form-check">
                      <input
                        v-model="roleForm.time_slots.saturday.is_checked"
                        class="form-check-input"
                        type="checkbox"
                        id="saturday"
                      />
                      <label class="" for="saturday">Saturday</label>
                    </div>
                    <div class="col-md-9">
                      <input
                        v-model="roleForm.time_slots.saturday.time"
                        placeholder="Time Slot"
                        class="form-control"
                        id="saturday-time"
                        type="text"
                        name="saturday-time"
                      />
                    </div>
                  </div>

                  <div class="row align-items-center mb-3">
                    <div class="col-3 form-check">
                      <input
                        v-model="roleForm.time_slots.sunday.is_checked"
                        class="form-check-input"
                        type="checkbox"
                        id="sunday"
                      />
                      <label class="" for="sunday">Sunday</label>
                    </div>
                    <div class="col-md-9">
                      <input
                        v-model="roleForm.time_slots.sunday.time"
                        placeholder="Time Slot"
                        class="form-control"
                        id="sunday-time"
                        type="text"
                        name="sunday-time"
                      />
                    </div>
                  </div>

                  <!-- <div>
                  <textarea
                      v-model="roleForm.time_slots"
                      class="form-control"
                      name="time_slots"
                      :class="{
                      'is-invalid': rolesubmit && $v.roleForm.time_slots.$error,
                    }"
                      rows="3" placeholder="Enter Time Slots"
                  ></textarea>
                    <div
                        v-if="rolesubmit && $v.roleForm.time_slots.$error"
                        class="invalid-feedback"
                    >
                    <span v-if="!$v.roleForm.time_slots.required"
                    >Time Slots is required.</span
                    >
                    </div>
                  </div> -->
                </div>

                <div class="mb-3">
                  <label class="mt-0">Select Status</label>
                  <b-form-select
                    class="form-select"
                    v-model="roleForm.status"
                    :options="status"
                    :class="{
                      'is-invalid': rolesubmit && $v.roleForm.status.$error,
                    }"
                  >
                    <option slot="first" :value="null" disabled>
                      Select Status
                    </option>
                  </b-form-select>
                  <div
                    v-if="rolesubmit && $v.roleForm.status.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.roleForm.status.required"
                      >Status is required.</span
                    >
                  </div>
                </div>

                <!--                <div class="mb-3">

                  <label class="mt-0">Select Location</label>
                  <b-form-select class="form-select" v-model="roleForm.location_id" :options="locations"
                                 value-field="id"
                                 text-field="name"
                                 :class="{'is-invalid': rolesubmit && $v.roleForm.location_id.$error,}"
                  >
                    <option slot="first" :value="null" disabled>Select Location</option>
                  </b-form-select>
                  <div
                      v-if="rolesubmit && $v.roleForm.location_id.$error"
                      class="invalid-feedback"
                  >
                  <span v-if="!$v.roleForm.location_id.required"
                  >Location is required.</span>
                  </div>

                </div>-->

                <div class="mb-3">
                  <label class="mt-0">Select Category</label>
                  <b-form-select
                    class="form-select"
                    v-model="roleForm.category_id"
                    :options="categories"
                    value-field="id"
                    text-field="name"
                    :class="{
                      'is-invalid':
                        rolesubmit && $v.roleForm.category_id.$error,
                    }"
                  >
                    <option slot="first" :value="null" disabled>
                      Select Category
                    </option>
                  </b-form-select>
                  <div
                    v-if="rolesubmit && $v.roleForm.category_id.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.roleForm.category_id.required"
                      >Category is required.</span
                    >
                  </div>
                </div>

                <div class="row">
                  <div class="col-4">
                    <div class="mb-3">
                      <label class="mt-0">Select Type</label>
                      <b-form-select
                        class="form-select"
                        v-model="roleForm.type"
                        :options="types"
                        :class="{
                          'is-invalid': rolesubmit && $v.roleForm.type.$error,
                        }"
                      >
                        <option slot="first" :value="null" disabled>
                          Select Type
                        </option>
                      </b-form-select>
                      <div
                        v-if="rolesubmit && $v.roleForm.type.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.roleForm.type.required"
                          >Type is required.</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="mb-3">
                      <label>Age Limit</label>
                      <input
                        v-model="roleForm.age_limit"
                        type="number"
                        class="form-control"
                        placeholder="Enter Age Limit"
                        name="category"
                        :class="{
                          'is-invalid':
                            rolesubmit && $v.roleForm.age_limit.$error,
                        }"
                      />
                      <div
                        v-if="rolesubmit && $v.roleForm.age_limit.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.roleForm.age_limit.required"
                          >Age Limit is required.</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="mb-3">
                      <label>Capacity</label>
                      <input
                        v-model="roleForm.capacity"
                        type="number"
                        class="form-control"
                        placeholder="Enter Capacity"
                        name="capacity"
                        :class="{
                          'is-invalid':
                            rolesubmit && $v.roleForm.capacity.$error,
                        }"
                      />
                      <div
                        v-if="rolesubmit && $v.roleForm.capacity.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.roleForm.capacity.required"
                          >Capacity is required.</span
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mb-0">
                  <div>
                    <button
                      type="button"
                      v-if="isAdd"
                      @click="saveRole"
                      class="btn btn-primary"
                    >
                      Add Role
                    </button>
                    <button
                      type="button"
                      v-if="isUpdate"
                      @click="updateRole"
                      class="btn btn-primary"
                    >
                      Update Role
                    </button>
                  </div>
                </div>
              </form>
            </b-modal>
          </div>
        </div>

        <form class="row align-items-center form-inline mb-4 border p-3 m-0">
          <div class="col-md-12">
            <h4 class="font-size-14">Search By:</h4>
          </div>
          <div class="col-md-4">
            <select
              class="form-select custom-select"
              v-model="searchBy"
              @change="searchOption($event)"
            >
              <option value="">Select Option</option>
              <option value="name">Role Name</option>
              <option value="category">Category Name</option>
              <option value="status">Status</option>
            </select>
          </div>
          <div class="col-md-2 sm-hidden xs-hidden"></div>
          <div class="col-md-6 pull-right">
            <div class="row app-search pt-0 pb-0">
              <div class="col-md-12 d-flex">
                <input
                  v-if="isName"
                  v-model="searchForm.name"
                  type="text"
                  class="ps-4 form-control"
                  placeholder="Type Role"
                />
                <input
                  v-if="isCategory"
                  v-model="searchForm.category"
                  type="text"
                  class="ps-4 form-control"
                  placeholder="Type Category"
                />
                <b-form-select
                  v-if="isStatus"
                  class="form-select"
                  v-model="searchForm.status"
                  :options="status"
                >
                  <option slot="first" :value="null" disabled>
                    Select Status
                  </option>
                </b-form-select>

                <b-button
                  v-if="isSearching"
                  class="btn-find"
                  id="show-btn"
                  @click="searchRoles"
                  variant="primary"
                  title="Search"
                >
                  <i class="bx bx-search-alt-2"> Search</i>
                </b-button>

                <b-button
                  v-if="isSearching"
                  class="btn-reset ms-2"
                  id="show-btn"
                  @click="resetSearch"
                  variant="primary"
                  title="Reset"
                >
                  <i class="bx bx-reset"> Reset</i>
                </b-button>
              </div>
            </div>
          </div>
        </form>

        <div class="table-responsive">
          <table
            class="table table-bordered table-hover table-striped table-sm align-middle table-nowrap mb-0"
          >
            <thead class="table-light">
              <tr>
                <th scope="col">Role</th>
                <th scope="col">Status</th>
                <th scope="col">Description</th>
                <th scope="col">Age Limit</th>
                <!--              <th scope="col">Location</th>-->
                <th scope="col">Category</th>
                <th scope="col">Capacity</th>
                <th scope="col">Assigned</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="noRecord">
                <td colspan="8" class="p-0">
                  <p class="font-size-16 text-center mt-2 mb-0">
                    Record Not Found!
                  </p>
                </td>
              </tr>

              <tr v-if="isLoading">
                <td colspan="8" class="text-center p-0">
                  <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                </td>
              </tr>

              <tr v-else v-for="(role, index) in roles" :key="index">
                <td>
                  <h5 class="font-size-13 text-truncate mb-1">
                    {{ role.name }}
                  </h5>
                </td>
                <td>
                  <h5 class="font-size-13 text-truncate mb-1 text-capitalize">
                    {{ role.status }}
                  </h5>
                </td>
                <td>
                  <p class="text-muted mb-0 text-wrap">
                    {{ role.description.substr(0, 50) + "..." }}
                  </p>
                </td>
                <td>
                  <p class="text-muted mb-0 text-wrap text-center">
                    {{ role.age_limit }}
                  </p>
                </td>
                <td>
                  <p class="text-muted mb-0 text-wrap">
                    {{ role.category ? role.category.name : "-" }}
                  </p>
                </td>
                <td>
                  <p
                    class="text-muted mb-0 text-wrap text-capitalize text-center"
                  >
                    {{ role.capacity }}
                  </p>
                </td>
                <td>
                  <p
                    class="text-muted mb-0 text-wrap text-capitalize text-center"
                  >
                    {{ role.assigned }}
                  </p>
                </td>
                <td class="text-center">
                  <b-button
                    id="show-btn"
                    @click="showEditModal(role)"
                    variant="primary"
                    title="Edit"
                  >
                    <i class="bx bx-pencil"></i>
                  </b-button>
                  <b-button
                    @click="deleteRole(role)"
                    class="ms-2"
                    variant="danger"
                    title="Delete"
                  >
                    <i class="bx bx-trash"></i>
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <pagination
          class="mt-4"
          :data="roles"
          :limit="10"
          @pagination-change-page="getRoles"
        ></pagination>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
.form-check-input {
  margin-left: -6px;
  margin-right: 5px;
}

.mdl-btns button:nth-child(1) {
  margin-right: 1rem;
}

.app-search input,
.app-search select {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}

.app-search .btn-find {
  width: 40%;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  box-shadow: none;
}

.app-search .btn-reset {
  width: 40%;
  font-size: 15px;
  box-shadow: none;
  border-radius: 30px;
}
</style>
